import React from 'react';
import MenuList from '@mui/material/Menu';
import { MenuItem } from './menu-item';
import { IUseMenu } from './IUseMenu';
import { IProps as IMainProps } from './IProps';

interface IProps
    extends Pick<IMainProps, 'onHoverStop' | 'onHoverStart' | 'items'>,
        Omit<IUseMenu, 'onOpen' | 'onBtnClick'> {}

const Component: React.FC<IProps> = ({
    items,
    anchor,
    onClose,
    onItemClick,
    onBtnKeyDown,
    onHoverStart,
    onHoverStop,
}: IProps) => {
    return (
        <MenuList
            classes={{
                paper: 'menu__list',
            }}
            open={Boolean(anchor)}
            anchorEl={anchor}
            onClose={onClose}
            onTouchStartCapture={onHoverStart}
            onTouchEndCapture={onHoverStop}
            onMouseOver={onHoverStart}
            onMouseOut={onHoverStop}
            onMouseEnter={onHoverStart}
            onMouseLeave={onHoverStop}
            onFocus={onHoverStart}
            onBlur={onHoverStop}
        >
            {items.map(({ id, text, icon, onClick, onKeyDown }, i) => (
                <MenuItem
                    text={text}
                    id={id}
                    icon={icon}
                    onClick={onClick}
                    onItemClick={onItemClick}
                    onKeyDown={onKeyDown || onBtnKeyDown}
                    key={`${text}${i}`}
                />
            ))}
        </MenuList>
    );
};

export const MenuItems = React.memo(Component);
